(function () {
  const config = window.freeGiftPromotionConfig;
  const bindingFlag = '__snooozeFreeGiftOfferTrackingBound';

  if (!config || !config.enabled || window[bindingFlag]) return;
  window[bindingFlag] = true;

  const eventName = 'free_gift_offer_click';
  const promotionCode = String(config.promotionCode || 'silk_mask_88');
  const threshold = Number(config.thresholdCents || 0) / 100;
  const giftValue = Number(config.giftValueCents || 0) / 100;
  const currency = String(config.currency || 'GBP').toUpperCase();

  function trackingPayload(link) {
    return {
      placement: String(link.dataset.freeGiftPlacement || 'unknown'),
      promotion_code: promotionCode,
      threshold,
      gift_value: giftValue,
      currency,
      destination: 'silk_mask_offer',
      link_url: link.href
    };
  }

  function publishOfferClick(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });

    const analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === 'function') {
      try {
        analytics.publish(eventName, payload);
      } catch (error) {
        // The destination URL still records the placement in the GA4 page view.
      }
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('[data-free-gift-offer-link]');
    if (!link) return;

    publishOfferClick(trackingPayload(link));
  }, true);
})();
